import type { IconProps } from './IconLibrary';

function BushIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <ellipse cx="12" cy="27" rx="8" ry="7" fill="#6aab6a" stroke="#2f2f2f" strokeWidth="1.5" />
      <ellipse cx="28" cy="27" rx="8" ry="7" fill="#6aab6a" stroke="#2f2f2f" strokeWidth="1.5" />
      <ellipse cx="20" cy="22" rx="10" ry="8.5" fill="#7bbf7b" stroke="#2f2f2f" strokeWidth="1.5" />
    </svg>
  );
}

export default BushIcon;
